import { authApi } from "./index";

export const connectStripeExpress = async (returnUrl, refreshUrl) => {
  try {
    const response = await authApi.post(
      `/Payments/connect-stripe?returnUrl=${encodeURIComponent(returnUrl)}&refreshUrl=${encodeURIComponent(refreshUrl)}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to initiate Stripe Connect Express onboarding:", error);
    throw error;
  }
};

export const getStripeStatus = async () => {
  try {
    const response = await authApi.get("/Payments/stripe-status");
    return response.data;
  } catch (error) {
    console.error("Failed to retrieve Stripe Connect status:", error);
    throw error;
  }
};

export const createCheckoutSession = async (bookingId, successUrl, cancelUrl) => {
  try {
    const response = await authApi.post("/Payments/checkout-session", {
      bookingId,
      successUrl,
      cancelUrl,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create Stripe Checkout session:", error);
    throw error;
  }
};

export const getStripeBalance = async () => {
  try {
    const response = await authApi.get("/Payments/stripe-balance");
    return response.data;
  } catch (error) {
    console.error("Failed to retrieve Stripe balance:", error);
    throw error;
  }
};

export const getStripeLoginLink = async () => {
  try {
    const response = await authApi.post("/Payments/stripe-login-link");
    return response.data;
  } catch (error) {
    console.error("Failed to create Stripe login link:", error);
    throw error;
  }
};

export const getEarningsSummary = async () => {
  try {
    const response = await authApi.get("/Payments/earnings-summary");
    return response.data;
  } catch (error) {
    console.error("Failed to retrieve earnings summary:", error);
    throw error;
  }
};
